import { render, staticRenderFns } from "./hotelBookingMode.vue?vue&type=template&id=fb2900d2&scoped=true&"
import script from "./hotelBookingMode.vue?vue&type=script&lang=js&"
export * from "./hotelBookingMode.vue?vue&type=script&lang=js&"
import style0 from "./hotelBookingMode.vue?vue&type=style&index=0&id=fb2900d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2900d2",
  null
  
)

export default component.exports